<template lang="pug">
.flex.items-center.gap-1
  p.text-2xl.font-medium.tracking-tight.font-serif.transition-colors.duration-150(
    v-if="!logo"
    :style="{ color: fill }"
  ) maksuni
  svg.svg-logo(
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 100 100"
    fill="none"
  )
    defs
      mask#cutout
        rect(
          width="100"
          height="100"
          fill="white"
        )
        circle(
          cx="-50"
          cy="50"
          r="80"
          fill="black"
        )
    g(
      :fill="fill"
      mask="url(#cutout)"
      stroke="none"
    )
      rect(x="10" y="15" width="80" height="12" rx="5")
      rect(x="0" y="35" width="80" height="12" rx="5")
      rect(x="10" y="55" width="80" height="12" rx="5")
      rect(x="0" y="75" width="80" height="12" rx="5")
</template>

<script>
export default {
  name: 'UiLogo',
  props: {
    logo: {
      type: Boolean,
      default: false
    },
    fill: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style lang="stylus" scoped>
.svg-logo g
  transition fill 150ms ease
</style>
